import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { isAgentPortal } from "js/utilities";

import getCompanyWideAlerts from "service/CSRAdminAlerts/GetAlerts";
import config from "config/config";
import moment from "moment/moment";
import { getToken } from "js/formatting/getToken";

async function getCompanyWideAlertArray() {
  let companyWideAlert = [];
  await getCompanyWideAlerts()
    .then((response) => {
      if (response && response?.activeAlerts?.length > 0) {
        companyWideAlert = response?.activeAlerts
          .filter(
            (a) =>
              moment(a.startDate) <= moment() &&
              a.group?.toLowerCase() === "companywide"
          )
          .map((alert) => {
            return {
              ...alert,
              title: "Company Alert",
              iconBorder: "ui-icon-border-good",
              detail: alert.message,
            };
          });
      }
    })
    .catch((error) => {
      console.error(error);
    });
  return companyWideAlert?.slice(0, parseInt(config.ALERTS_COUNT));
}
export const getAlerts = createAsyncThunk(
  "getAlerts",
  async (contractIds, { rejectWithValue, fulfillWithValue }) => {
    let alerts = [];
    const alertsNotFound = [
      {
        // uiTextColor: "text-ui-green",
        iconBorder: "ui-icon-border-good",
        detail: "There are no messages for your policies.",
      },
      {
        iconBorder: "ui-icon-border-good",
        detail: "To view additional alerts, please go to the",
      },
    ];
    try {
      let options = {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "Ocp-Apim-Subscription-Key": config.ODS_API_KEY,
          Authorization: `bearer ${getToken()}`,
        },
        body: JSON.stringify({
          gXdpApi: {
            transactionType: {
              eventName: "GETALERT",
              sourceNameSpace: "LIFESYS",
              targetNameSpace: "GIDP",
              operation: "GET",
            },
            gIdpPayLoad: {
              policyHolder: {
                phoneNumber: "",
                contractId: "",
                taxId: "",
                contractId_array: contractIds,
                dateOfBirth: "",
              },
              addOnProperties: {
                lifesys: {
                  policyHolder: {
                    company: config.COMPANY,
                    clientName: config.CLIENTNAME,
                    system: "LSN",
                    lifeSysDataset: "P",
                    searchType: "IN",
                    requestDomesticViolenceFlag: "",
                    recordsRequested: 10,
                    dvInclude: "",
                    includecomplianceFlag: "",
                    contractExpiryDuration: "",
                    suppressRider: "",
                    clientGroupSeach: "",
                    ShowTotalRequestTime: "",
                  },
                },
              },
            },
            parentCorrelationID: moment().format("YYYY-MM-DD HH:MM:SS"),
            correlationID: moment().format("YYYY-MM-DD HH:MM:SS"),
            addOnProperties: {},
          },
        }),
      };
      const response = await fetch(
        config.ODS_API_BASE_URL + "/evl/GetAlert",
        options
      );

      if (!response.ok) {
        if (response.status === 401) {
          rejectWithValue(response.status);
        } else return rejectWithValue(response.status);
      }

      const data = await response.json();
      if (data?.gXdpApi?.success) {
        let alertList = [];
        if (data?.gXdpApi?.gIdpPayLoad?.policyHolder?.alerts?.length > 0) {
          data?.gXdpApi?.gIdpPayLoad?.policyHolder?.alerts?.map((a) => {
            alertList = a?.messages?.map((policyAlert) => {
              return {
                ...policyAlert,
                policyNumber: a?.policy,
                memberID: a?.memberID,
                iconBorder: "ui-icon-border-good",
                title: `${
                  isAgentPortal() ? "Customer Alerts: " : ""
                }Contract Number - ${a?.memberID}`,
                annuityTitle: `Contract Number - ${a?.memberID}`,
                detail: policyAlert?.message,
              };
            });
          });
        }
        let companyWideAlerts = await getCompanyWideAlertArray();
        if (companyWideAlerts?.length > 0 && alertList?.length > 0) {
          alerts = companyWideAlerts.concat(
            alertList?.slice(0, parseInt(config.ALERTS_COUNT))
          );
        } else if (companyWideAlerts?.length > 0) {
          alerts = companyWideAlerts;
        } else if (alertList?.length > 0) {
          alerts = alertList;
        }
        if (alerts?.length > 0) {
          alerts.push({
            iconBorder: "ui-icon-border-good",
            detail: "To view additional alerts, please go to the",
          });
          return rejectWithValue({
            topNAlerts: alerts,
          });
        } else {
          return rejectWithValue({
            topNAlerts: alertsNotFound,
          });
        }
      } else {
        let companyWideAlerts = await getCompanyWideAlertArray();
        if (companyWideAlerts?.length > 0) {
          // Add Company wide alerts
          alerts = companyWideAlerts.concat({
            iconBorder: "ui-icon-border-good",
            detail: "To view additional alerts, please go to the",
          });
          return fulfillWithValue({
            topNAlerts: alerts,
          });
        } else {
          return fulfillWithValue({
            topNAlerts: alertsNotFound,
          });
        }
      }
    } catch (error) {
      return rejectWithValue({
        topNAlerts: alertsNotFound,
      });
    }
  }
);
const alertsSlice = createSlice({
  name: "Alerts",
  initialState: {
    isAlertsLoading: false,
    errorOnAlerts: "",
    alerts: [],
  },
  extraReducers: {
    [getAlerts.pending]: (state) => {
      state.isAlertsLoading = true;
    },
    [getAlerts.fulfilled]: (state, action) => {
      state.isAlertsLoading = false;
      state.alerts = action.payload;
    },
    [getAlerts.rejected]: (state, action) => {
      state.isAlertsLoading = false;
      state.errorOnAlerts = action;
      state.alerts = action.payload;
    },
  },
});

export default alertsSlice.reducer;
